import './App.css';
import ConverterPage from './pages/converter/converter.component';
import { ThemeProvider, createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#3c8dbc',
    },
    secondary: {
      main: '#b8c7ce',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <ConverterPage />
    </ThemeProvider>
  );
}

export default App;
